(function () {
  'use strict';

  function initUspCarousel(root) {
    var viewport = root.querySelector('[data-tg-usp-viewport]');
    var track = root.querySelector('[data-tg-usp-track]');
    var prevBtn = root.querySelector('[data-tg-usp-prev]');
    var nextBtn = root.querySelector('[data-tg-usp-next]');
    if (!viewport || !track) return;

    var items = Array.prototype.slice.call(track.querySelectorAll('[data-tg-usp-item]'));
    if (!items.length) return;

    var segmentSize = parseInt(root.getAttribute('data-tg-usp-segment-size'), 10) || Math.floor(items.length / 3);
    var segmentWidth = 0;

    var rafId = null;
    var isDragging = false;
    var dragStartX = 0;
    var dragStartScroll = 0;

    function measureSegment() {
      if (items.length >= segmentSize * 2) {
        segmentWidth = items[segmentSize].offsetLeft - items[0].offsetLeft;
      }
    }

    // Keeps the scroll position within the middle set, silently, so dragging
    // in either direction never runs out of content — the illusion of an
    // infinite loop without any visible jump (adjacent sets are identical).
    function maintainLoop() {
      if (!segmentWidth) return;
      if (viewport.scrollLeft < segmentWidth * 0.5) {
        viewport.scrollLeft += segmentWidth;
        // Keep the active drag's reference point in sync, otherwise the
        // next pointermove recalculates from the stale pre-shift baseline
        // and visibly yanks the track back.
        dragStartScroll += segmentWidth;
      } else if (viewport.scrollLeft > segmentWidth * 1.5) {
        viewport.scrollLeft -= segmentWidth;
        dragStartScroll -= segmentWidth;
      }
    }

    function updateActiveItem() {
      rafId = null;
      var viewportRect = viewport.getBoundingClientRect();
      var viewportCenter = viewportRect.left + viewportRect.width / 2;

      var closestItem = null;
      var closestDistance = Infinity;

      items.forEach(function (item) {
        var rect = item.getBoundingClientRect();
        var itemCenter = rect.left + rect.width / 2;
        var distance = Math.abs(itemCenter - viewportCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestItem = item;
        }
      });

      items.forEach(function (item) {
        item.classList.toggle('is-active', item === closestItem);
      });

      maintainLoop();
    }

    function requestUpdate() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(updateActiveItem);
    }

    viewport.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', function () {
      measureSegment();
      requestUpdate();
    });

    function scrollToItem(item) {
      if (!item) return;
      var viewportRect = viewport.getBoundingClientRect();
      var itemRect = item.getBoundingClientRect();
      var currentScroll = viewport.scrollLeft;
      var delta = (itemRect.left + itemRect.width / 2) - (viewportRect.left + viewportRect.width / 2);
      viewport.scrollTo({ left: currentScroll + delta, behavior: 'smooth' });
    }

    function getActiveIndex() {
      var activeItem = items.filter(function (item) {
        return item.classList.contains('is-active');
      })[0];
      var index = items.indexOf(activeItem);
      return index === -1 ? 0 : index;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var index = getActiveIndex();
        var target = items[(index - 1 + items.length) % items.length];
        scrollToItem(target);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var index = getActiveIndex();
        var target = items[(index + 1) % items.length];
        scrollToItem(target);
      });
    }

    // Pointer drag / swipe support.
    viewport.addEventListener('pointerdown', function (event) {
      isDragging = true;
      dragStartX = event.clientX;
      dragStartScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(event.pointerId);
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!isDragging) return;
      var delta = event.clientX - dragStartX;
      viewport.scrollLeft = dragStartScroll - delta;
      requestUpdate();
    });

    function endDrag(event) {
      if (!isDragging) return;
      isDragging = false;
      viewport.classList.remove('is-dragging');
      try {
        viewport.releasePointerCapture(event.pointerId);
      } catch (e) {
        // Ignore — pointer may have already been released.
      }
      requestUpdate();
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('pointerleave', function () {
      if (isDragging) isDragging = false;
      viewport.classList.remove('is-dragging');
    });

    // Center the initial slide (middle icon of the middle set) once images
    // have laid out, then measure the set width for the loop maintenance.
    window.requestAnimationFrame(function () {
      measureSegment();
      var middleItem = items[Math.floor(items.length / 2)];
      if (middleItem) {
        scrollToItem(middleItem);
      }
      requestUpdate();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-tg-usp-carousel]').forEach(initUspCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-tg-usp-carousel]');
    if (root) initUspCarousel(root);
  });
})();
